import Categorias from "./Categorias";
export default Categorias;